module.exports = __webpack_public_path__ + "img/login-right.83450991.png";